import { Box, Colors, Icon, MediumIcon } from '@factorialco/deprecated-design-system'

import { useMemo } from 'modules/core/hooks/useMemo'

interface ItemIconProps {
  configurationType: string | null | undefined
}

export const ItemIcon = ({ configurationType }: ItemIconProps) => {
  const styles = useMemo((): {
    icon: MediumIcon
    backgroundColor: Colors
    color: Colors
  } => {
    switch (configurationType) {
      case 'Processes::TaskConfiguration':
        return {
          icon: 'check',
          backgroundColor: 'malibu200',
          color: 'malibu1000',
        }
      case 'Processes::Action':
        return {
          icon: 'thunder',
          backgroundColor: 'tangerine200',
          color: 'tangerine1000',
        }
      default:
        return {
          icon: 'check',
          backgroundColor: 'grey200',
          color: 'grey1000',
        }
    }
  }, [configurationType])

  return (
    <Box background={styles.backgroundColor} borderRadius={{ all: 'abs008' }}>
      <Icon.Medium icon={styles.icon} color={styles.color}></Icon.Medium>
    </Box>
  )
}
